import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\OpenAI\GetMessageTextFromOpenAIController::__invoke
* @see app/Http/Controllers/OpenAI/GetMessageTextFromOpenAIController.php
* @route '/api/ai/generate'
*/
const GetMessageTextFromOpenAIController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetMessageTextFromOpenAIController.url(options),
    method: 'post',
})

GetMessageTextFromOpenAIController.definition = {
    methods: ["post"],
    url: '/api/ai/generate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\OpenAI\GetMessageTextFromOpenAIController::__invoke
* @see app/Http/Controllers/OpenAI/GetMessageTextFromOpenAIController.php
* @route '/api/ai/generate'
*/
GetMessageTextFromOpenAIController.url = (options?: RouteQueryOptions) => {
    return GetMessageTextFromOpenAIController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\OpenAI\GetMessageTextFromOpenAIController::__invoke
* @see app/Http/Controllers/OpenAI/GetMessageTextFromOpenAIController.php
* @route '/api/ai/generate'
*/
GetMessageTextFromOpenAIController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetMessageTextFromOpenAIController.url(options),
    method: 'post',
})

export default GetMessageTextFromOpenAIController